import { Component } from '@angular/core';

@Component({
standalone: false,
  selector: 'app-change-password-container',
  styleUrls: ['./change-password-container.component.scss'],
  templateUrl: './change-password-container.component.html',
})
export class ChangePasswordContainerComponent {
  constructor() {}
}
